import { render, staticRenderFns } from "./MineButton.vue?vue&type=template&id=94f57b50&scoped=true"
import script from "./MineButton.vue?vue&type=script&lang=js"
export * from "./MineButton.vue?vue&type=script&lang=js"
import style0 from "./MineButton.vue?vue&type=style&index=0&id=94f57b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f57b50",
  null
  
)

export default component.exports